(function () {

    angular
        .module('smartertoolsApp')
        .factory('resellersService', ['$http', 'refreshToken', 'cacheControl', '$rootScope', resellersService]);

    function resellersService($http, refreshToken, cacheControl, $rootScope) {
        const urlBase = apiRootUrl;
        let p1;
        let p2;
        let getPricingTablePromise;

        const dataFactory = {};
        dataFactory.getUnassignedLicenses = getUnassignedLicenses;
        dataFactory.getCustomers = getCustomers;
        dataFactory.getPricingTable = getPricingTable;
        dataFactory.resendLicenseEmail = resendLicenseEmail;
        dataFactory.assignLicense = assignLicense;
        return dataFactory;

        // -----------------------------------------------

        function getUnassignedLicenses(clearCache) {
            if (p1)
                return p1;
            if (clearCache)
                cacheControl.getCache('resellerCache').removeAll();
            p1 = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/resellers/licenses/unassigned`, { cache: cacheControl.getCache('resellerCache') }))
                .then((response) => {
                    p1 = null;
                    return response.data.Licenses;
                });
            return p1;
        }

        function getCustomers(clearCache) {
            if (p2)
                return p2;
            if (clearCache)
                cacheControl.getCache('resellerCache').removeAll();
            p2 = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/resellers/customers`, { cache: cacheControl.getCache('resellerCache') }))
                .then((response) => {
                    p2 = null;
                    return response.data.Customers;
                });
            return p2;
        }

        function getPricingTable() {
            if (getPricingTablePromise)
                return getPricingTablePromise;
            getPricingTablePromise = refreshToken.refreshToken()
                .then(() => $http.get(`${urlBase}v1/account/resellers/pricing`, { cache: cacheControl.getCache('myAccountCache') }))
                .then((response) => {
                    getPricingTablePromise = null;
                    return response.data.Categories;
                });
            return getPricingTablePromise;
        }

        function resendLicenseEmail(licenseKey) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/account/resellers/resend-license-email`, JSON.stringify({ LicenseKey: licenseKey })))
                .then((response) => response.data);
        }

        function assignLicense(licenseKey, emailAddress) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${urlBase}v1/account/resellers/assign-license`, JSON.stringify({ LicenseKey: licenseKey, EmailAddress: emailAddress })))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }
    }

})();